import { VERBS } from "./content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {VERBS.map((v, i) => (
      <span key={v} className="flex items-center">
        <span className={`font-serif-d px-8 text-6xl sm:text-8xl ${i % 2 ? "text-outline italic" : "text-white"}`}>{v}</span>
        <span className="h-3 w-3 rounded-full bg-[var(--teal)]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-white/5 bg-[var(--navy)] py-10" data-testid="verb-marquee" aria-label="Action verbs">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </section>
);
